// import Popup from '../components/map-view/Popup.vue';
import Popup from '../views/map2d/Popup.vue';
export default {
    props: ['feature'],
    components: { Popup },
};
